import Table from 'react-bootstrap/Table';
import './AppDetails.css';
const AppDetails = (props: any) => {
  return (
    <>
      <div className="row text-center">
        <div className="col-sm-6 col-md-10">
          <h3>Onboarded Applications</h3>
        </div>
        <div className="col-6 col-md-2">
          <button
            type="button"
            style={{
              width: 'fit-content'
            }}
            onClick={props.onBackClick}
            className="mb-4 btn uniBtnYellow">
            Back
          </button>
        </div>
      </div>

      <Table responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>Application Name</th>
            <th>Models</th>
            <th>Onboarded to RAG</th>
            <th>Env</th>
            {/* <th>Edit</th> */}
          </tr>
        </thead>
        <tbody>
          {props.appList.map((app: any) => (
            <tr key={app.onboarding_id}>
              <td>{app.onboarding_id}</td>
              <td>{app.application_name}</td>

              <td>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  {app.model_name.map((model: string, index: number) => (
                    <span key={index}>{model}</span>
                  ))}
                </div>
              </td>

              <td>{app.aif_rag_access?'Yes':'No'}</td>

              <td>
              
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  {app.environment.map((env: string, index: number) => (
                    <span key={index}>{env}</span>
                  ))}
                </div>
              </td>

              {/* <td>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-pencil-fill edit-pen"
                  viewBox="0 0 16 16"
                  onClick={()=>props.onEditClick(app.onboarding_id)}>
                  <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                </svg>
              </td> */}
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};
export default AppDetails;
